<template>
  <div class="flex h-screen justify-center items-center p-10">
    <div class="text-center space-y-8 text-lg">
      <div>
        <div class="flex justify-center">
          <LockClosedIcon class="w-16 h-16" />
        </div>
        <div>{{ albumInfo?.title }}</div>
      </div>
      <div class="flex gap-2">
        <input
          v-model="password"
          type="password"
          placeholder="password"
          :class="inputClassObj"
        />
        <MyButton @click="submit">Submit</MyButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import MyButton from "~/components/MyButton.vue";
import { LockClosedIcon } from "@heroicons/vue/20/solid";

export default defineComponent({
  components: { LockClosedIcon, MyButton },

  setup() {
    definePageMeta({
      layout: "headless",
    });

    const route = useRoute();
    const slug = route.params.slug as string;
    const api = useApi();

    const { data: albumInfo } = useAsyncData(() =>
      api.albumPassword.getAlbumSlugAuth(slug)
    );

    return { api, albumInfo, slug };
  },

  data() {
    return {
      password: null,
      error: false,
    };
  },
  computed: {
    inputClassObj() {
      return {
        "input--error": this.error,
      };
    },
  },
  methods: {
    async submit() {
      try {
        const slug = this.albumInfo?.slug;

        if (slug && this.password) {
          await this.api.albumPassword.postAlbumSlugAuth(slug, {
            password: this.password,
          });

          // Some timing issue here between the cookie being set(above) and the redirect.
          // perhaps put a breakpoint on the redirected page to see why it fails and redirects back here.

          // setTimeout(() => {

          navigateTo({
            name: "slug",
            params: { slug },
          });
          // });
        }
      } catch (e) {
        this.error = true;
      }
    },
  },
});
</script>

<style lang="postcss">
input,
select {
  @apply bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500;
}
.input--error {
  @apply border border-red-500;
}
</style>
